import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';

export default function DemoHubScreen() {
  const { demoHub, toast } = useApp();
  const [catFilter, setCatFilter] = useState('all');
  const [search, setSearch] = useState('');

  const filtered = demoHub.demos.filter(d => {
    const matchesCat = catFilter === 'all' || d.category === catFilter;
    const matchesSearch = !search || d.title.toLowerCase().includes(search.toLowerCase()) || d.description.toLowerCase().includes(search.toLowerCase());
    return matchesCat && matchesSearch;
  });

  const totalViews = demoHub.demos.reduce((a, d) => a + d.views, 0);
  const totalVisitors = demoHub.demos.reduce((a, d) => a + d.uniqueVisitors, 0);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '16px 24px 12px', borderBottom: '1px solid var(--border)', flexShrink: 0, background: 'white' }}>
        <div style={{ width: '38px', height: '38px', borderRadius: '11px', background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <i className="ti ti-presentation-analytics" style={{ fontSize: '20px', color: '#6366F1' }} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '20px', fontWeight: '800', color: 'var(--navy)' }}>Demo Hub</div>
          <div style={{ fontSize: '12px', color: 'var(--text3)' }}>Create interactive demo journeys · Share with tracking · Public gallery</div>
        </div>
        <button onClick={() => toast('Demo builder coming soon!')} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '9px 18px', borderRadius: '9px', background: '#6366F1', border: 'none', color: 'white', fontFamily: 'inherit', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>
          <i className="ti ti-plus" /> New Demo
        </button>
        <button onClick={() => toast('Public gallery opened!')} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '9px 14px', borderRadius: '9px', background: 'var(--surface)', border: '1.5px solid var(--border)', color: 'var(--navy)', fontFamily: 'inherit', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
          <i className="ti ti-world" /> Public Gallery
        </button>
      </div>

      {/* Stats bar */}
      <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', flexShrink: 0, background: 'white' }}>
        {[{ icon: 'ti-presentation-analytics', label: 'Total Demos', val: demoHub.demos.length, color: '#6366F1', bg: '#EEF2FF' }, { icon: 'ti-eye', label: 'Total Views', val: totalViews, color: '#0078D4', bg: '#EBF8FF' }, { icon: 'ti-users', label: 'Unique Visitors', val: totalVisitors, color: '#22C55E', bg: '#F0FFF4' }, { icon: 'ti-user-check', label: 'Gate Completions', val: demoHub.sessions.length, color: '#C8973A', bg: '#FDF4E7' }].map(s => (
          <div key={s.label} style={{ flex: 1, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '10px', borderRight: '1px solid var(--border)' }}>
            <div style={{ width: '34px', height: '34px', borderRadius: '9px', background: s.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <i className={`ti ${s.icon}`} style={{ fontSize: '16px', color: s.color }} />
            </div>
            <div>
              <div style={{ fontSize: '18px', fontWeight: '800', color: 'var(--navy)', lineHeight: 1 }}>{s.val}</div>
              <div style={{ fontSize: '10px', color: 'var(--text3)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '.05em' }}>{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Filter tabs + search */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 24px', borderBottom: '1px solid var(--border)', flexShrink: 0, background: 'var(--surface)' }}>
        <div style={{ display: 'flex', gap: '4px' }}>
          {['all', ...demoHub.categories].map(cat => (
            <button key={cat} onClick={() => setCatFilter(cat)} style={{ padding: '5px 13px', borderRadius: '20px', border: '1.5px solid', fontFamily: 'inherit', fontSize: '12px', fontWeight: '500', cursor: 'pointer', background: catFilter === cat ? 'var(--navy)' : 'white', borderColor: catFilter === cat ? 'var(--navy)' : 'var(--border2)', color: catFilter === cat ? 'white' : 'var(--text2)' }}>
              {cat === 'all' ? 'All' : cat}
            </button>
          ))}
        </div>
        <div style={{ marginLeft: 'auto', position: 'relative' }}>
          <i className="ti ti-search" style={{ position: 'absolute', left: '9px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', color: 'var(--text3)' }} />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search demos…" style={{ padding: '7px 10px 7px 28px', border: '1.5px solid var(--border2)', borderRadius: '8px', fontFamily: 'inherit', fontSize: '12px', width: '200px', background: 'white', outline: 'none' }} />
        </div>
      </div>

      {/* Demo cards grid */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(320px,1fr))', gap: '16px', alignContent: 'start' }}>
          {filtered.map(demo => (
            <div key={demo.id} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '14px', overflow: 'hidden' }}>
              {/* Thumbnail */}
              <div style={{ height: '140px', background: `linear-gradient(135deg, #4F46E5, #818CF8)`, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', position: 'relative' }}
                onClick={() => toast('Demo builder opening…')}>
                {demo.persona && <span style={{ position: 'absolute', top: '10px', left: '10px', fontSize: '10px', fontWeight: '700', padding: '3px 10px', borderRadius: '20px', background: 'rgba(0,0,0,.4)', color: 'white' }}>{demo.persona}</span>}
                <span style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '10px', fontWeight: '700', padding: '3px 10px', borderRadius: '20px', background: demo.mode === 'live' ? 'rgba(239,68,68,.8)' : 'rgba(0,0,0,.4)', color: 'white' }}>{demo.mode}</span>
                <i className="ti ti-presentation-analytics" style={{ fontSize: '48px', color: 'rgba(255,255,255,.7)' }} />
              </div>

              <div style={{ padding: '14px 16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginBottom: '6px' }}>
                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: demo.status === 'live' ? '#22C55E' : '#CBD5E0', display: 'inline-block', flexShrink: 0 }} />
                  <span style={{ fontSize: '14px', fontWeight: '700', color: 'var(--navy)', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{demo.title}</span>
                </div>
                <p style={{ fontSize: '12px', color: 'var(--text3)', lineHeight: 1.5, marginBottom: '10px' }}>{demo.description}</p>

                {/* Stats */}
                <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                  {[{ icon: 'ti-eye', val: demo.views, label: 'Views' }, { icon: 'ti-users', val: demo.uniqueVisitors, label: 'Visitors' }, { icon: 'ti-clock', val: demo.avgTime, label: 'Avg' }, { icon: 'ti-circle-check', val: `${demo.completionRate}%`, label: 'Done' }].map(s => (
                    <div key={s.label} style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '14px', fontWeight: '700', color: 'var(--navy)' }}>{s.val}</div>
                      <div style={{ fontSize: '9px', color: 'var(--text3)', fontWeight: '600', textTransform: 'uppercase' }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                {/* Secondary actions */}
                <div style={{ display: 'flex', gap: '4px', marginBottom: '10px' }}>
                  {[{ icon: 'ti-edit', label: 'Edit' }, { icon: 'ti-share', label: 'Share' }, { icon: 'ti-chart-bar', label: 'Stats' }].map(a => (
                    <button key={a.label} onClick={() => toast(`${a.label} clicked`)} style={{ flex: 1, padding: '5px 4px', border: '1px solid var(--border2)', borderRadius: '6px', background: 'none', fontFamily: 'inherit', fontSize: '10px', color: 'var(--text3)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
                      <i className={`ti ${a.icon}`} style={{ fontSize: '10px' }} /> {a.label}
                    </button>
                  ))}
                </div>

                {/* Primary CTAs */}
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => toast('Launching live demo…')} style={{ flex: 1, padding: '10px', borderRadius: '9px', background: 'var(--navy)', border: 'none', color: 'white', fontFamily: 'inherit', fontSize: '12px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '7px' }}>
                    <i className="ti ti-player-play-filled" style={{ fontSize: '14px' }} />
                    <div style={{ textAlign: 'left' }}>
                      <div>Present Live</div>
                      <div style={{ fontSize: '9px', opacity: .7 }}>With rep notes</div>
                    </div>
                  </button>
                  <button onClick={() => toast('Buyer link copied!')} style={{ flex: 1, padding: '10px', borderRadius: '9px', background: '#6366F1', border: 'none', color: 'white', fontFamily: 'inherit', fontSize: '12px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '7px' }}>
                    <i className="ti ti-send" style={{ fontSize: '14px' }} />
                    <div style={{ textAlign: 'left' }}>
                      <div>Send to Buyer</div>
                      <div style={{ fontSize: '9px', opacity: .7 }}>Self-guided link</div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
